/** Card processing fee handling for HitPay payment links (post-WON invoice management). */

export type CardFeeMode = "pass_through" | "absorb";

export const DEFAULT_CARD_FEE_PERCENT = 3.5;

export type CardPaymentPreview = {
  invoiceAmount: number;
  cardFeePercent: number;
  cardFeeAmount: number;
  customerPays: number;
  companyReceives: number;
  mode: CardFeeMode;
};

export function roundSgd2(n: number): number {
  return Math.round(n * 100) / 100;
}

/**
 * @param invoiceAmount — invoice total the company expects to collect (after GST, before card fee).
 */
export function computeCardPaymentPreview(
  invoiceAmount: number,
  cardFeePercent: number,
  mode: CardFeeMode,
): CardPaymentPreview {
  const base = roundSgd2(Math.max(0, invoiceAmount));
  const pct = Math.max(0, cardFeePercent);
  const cardFeeAmount = roundSgd2(base * (pct / 100));

  if (mode === "pass_through") {
    return {
      invoiceAmount: base,
      cardFeePercent: pct,
      cardFeeAmount,
      customerPays: roundSgd2(base + cardFeeAmount),
      companyReceives: base,
      mode,
    };
  }

  return {
    invoiceAmount: base,
    cardFeePercent: pct,
    cardFeeAmount,
    customerPays: base,
    companyReceives: roundSgd2(base - cardFeeAmount),
    mode,
  };
}
